export default __webpack_public_path__ + "static/media/audit-active.ef0a0497.svg";